(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["combo-customizer"] && !Shopify.designMode) return;
  try {
    class ComboCustomizer extends HTMLElement {
    connectedCallback() {
      // Nome/número: só entram no carrinho quando têm texto.
      this.querySelectorAll('[data-cmb-prop]').forEach((input) => {
        input.addEventListener('input', () => {
          if (input.hasAttribute('data-upper')) input.value = input.value.toUpperCase();
          if (input.hasAttribute('data-num')) input.value = input.value.replace(/[^0-9]/g, '');
          if (input.value.trim() !== '') {
            input.setAttribute('name', `items[0][properties][${input.dataset.cmbProp}]`);
          } else {
            input.removeAttribute('name');
          }
        });
      });

      this.addEventListener('change', (event) => {
        const size = event.target.closest('[data-cmb-size]');
        if (size) {
          const label = this.querySelector(`[data-cmb-size-label="${size.dataset.cmbSize}"]`);
          if (label) label.textContent = size.value;
        }
      });

      this.addEventListener('click', (event) => {
        const patch = event.target.closest('[data-cmb-patch]');
        if (patch) return this.togglePatch(patch);
        if (event.target.closest('[data-cmb-clear]')) return this.clear();
      });
    }

    // Um patch por camisa; clicar de novo desmarca.
    togglePatch(button) {
      const j = button.dataset.jersey;
      const on = !button.classList.contains('is-selected');
      this.querySelectorAll(`[data-cmb-patch][data-jersey="${j}"]`).forEach((b) => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      const idField = this.querySelector(`[data-cmb-patch-id="${j}"]`);
      const forField = this.querySelector(`[data-cmb-patch-for="${j}"]`);
      const propField = this.querySelector(`[data-cmb-patch-prop="${j}"]`);
      const label = this.querySelector(`[data-cmb-patch-label="${j}"]`);

      if (on) {
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (idField) { idField.value = button.dataset.variantId; idField.disabled = false; }
        if (forField) forField.disabled = false;
        if (propField) { propField.value = button.dataset.patchName; propField.disabled = false; }
        if (label) label.textContent = button.dataset.patchName;
      } else {
        if (idField) { idField.value = ''; idField.disabled = true; }
        if (forField) forField.disabled = true;
        if (propField) { propField.value = ''; propField.disabled = true; }
        if (label) label.textContent = '';
      }
    }

    clear() {
      this.querySelectorAll('[data-cmb-prop]').forEach((input) => {
        input.value = '';
        input.removeAttribute('name');
      });
      this.querySelectorAll('[data-cmb-patch].is-selected').forEach((b) => this.togglePatch(b));
      const seen = {};
      this.querySelectorAll('[data-cmb-size]').forEach((radio) => {
        if (!seen[radio.name]) {
          seen[radio.name] = true;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  if (!customElements.get('combo-customizer')) {
    customElements.define('combo-customizer', ComboCustomizer);
  }
  } catch(e) { console.error(e); }
})();

})();
